import { Util } from 'reactstrap';
// css
// import 'bootstrap/dist/css/bootstrap.css';
// modules
import bootstrap from './bootstrap.module.scss';

Object.keys(bootstrap).forEach(function (key) {
  const camelCaseKey = key.replace(
    /([a-z0-9])-([a-z0-9])/g,
    function (fullMatch, matchOne, matchTwo, index) {
      return matchOne + matchTwo.toUpperCase();
    }
  );
  bootstrap[camelCaseKey] = bootstrap[key];
});

const cssModule = Object.assign({}, bootstrap);

Util.setGlobalCssModule(cssModule);
// console.log(JSON.stringify(Object.keys(cssModule)))
export default cssModule;



// WEBPACK FOOTER //
// ./src/theme/Bootstrap.js